import * as Yup from 'yup';

export enum IPaginatorQueryType {
    Elastic = "Elastic",
    Firebase = "Firebase"
}

export enum IFirebasePaginatorOperation {
    Prev = "Prev",
    Next = "Next",
    Reset = "Reset"
}

export const PAGINATOR_SCHEMA = Yup.object({
    type: Yup.string().default(IPaginatorQueryType.Firebase).defined(),
    totalPages: Yup.number().default(0).defined(),
    rowsPerPage: Yup.number().default(6).defined(),
    pageNumber: Yup.number().default(0).defined(),
    nextCursor: Yup.object(),
    prevCursor: Yup.object(),
    fbOperation: Yup.string().default(IFirebasePaginatorOperation.Reset)
}).defined();

type IPaginator = Yup.InferType<typeof PAGINATOR_SCHEMA>;

export const newPaginatorInstance = (rowsPerPage?:number):IPaginator => {
  const obj =  PAGINATOR_SCHEMA.cast();
  obj.rowsPerPage = rowsPerPage || 6;
  return Object.assign({},obj);
}

export default IPaginator;

/*export default interface IPaginator {
    type: IPaginatorQueryType;
    totalPages:number;
    rowsPerPage: number;
    pageNumber:number;
    nextCursor?: any;
    prevCursor?:any;
    fbOperation?:IFirebasePaginatorOperation;
}*/

/*export default class Paginator implements IPaginator{
    totalPages: number;
    pageNumber: number;
    rowsPerPage: number;
    nextCursor: any;
    prevCursor: any;
    onPaginate?: any;
    type: IPaginatorQueryType;
    fbOperation: IFirebasePaginatorOperation;
    callback:any

    constructor(callback:any){
        this.totalPages = 0;
        this.pageNumber = 0;
        this.rowsPerPage = 3;

        this.nextCursor = null;
        this.prevCursor = null;
        this.fbOperation = IFirebasePaginatorOperation.Reset;
        this.type = IPaginatorQueryType.Firebase;

        this.callback = callback;
    }

    public prev = () => {
        if(this.pageNumber > 0){
            if(this.type == IPaginatorQueryType.Elastic)
                this.pageNumber = this.pageNumber - 1;
            else if(this.type == IPaginatorQueryType.Firebase){
                this.fbOperation = IFirebasePaginatorOperation.Prev
            }
        }
        debugger;
        this.callback(this)
    }

    public next = () => {
        if(this.type == IPaginatorQueryType.Elastic){
            if(this.totalPages > this.pageNumber){}
                this.pageNumber = this.pageNumber + 1;
        } else if(this.type == IPaginatorQueryType.Firebase){
            this.fbOperation = IFirebasePaginatorOperation.Next
        }
        this.callback(this);
    }

    public goToPage = (pageNo:number) => {
        this.pageNumber = pageNo;
        this.callback(this)
    }

    private _getPaginatorState = () => {
        return {
            type: this.type,
            totalPages: this.totalPages,
            rowsPerPage: this.rowsPerPage,
            pageNumber: this.pageNumber,
            nextCursor: this.nextCursor,
            prevCursor: this.prevCursor
        }
    }

}*/